module.exports = __webpack_public_path__ + "img/logo.bbabb33a.png";